import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { VersionDto } from './dtos';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  apiName = 'General';
  

  getVersion = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, VersionDto>({
      method: 'GET',
      url: '/api/general/versions',
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
